<template>
  <div>
    <!-- file type selection -->
    <ak-pack class="file-type">
      <!-- file type -->
      <ak-pack-item class="one-half mb-tiny">
        <ak-field label="File type" margin-bottom="mb-0" required>
          <ak-select
            v-model="fileType"
            :options="fileTypes"
            track-by="value"
            label="label"
            placeholder="Select File Type"
            required
          />
        </ak-field>
      </ak-pack-item>
    </ak-pack>
    <!-- delimiter configurable -->
    <ak-pack>
      <ak-pack-item
        v-if="fileType && fileType.configurables.delimiter"
        class="one-half mb-small"
      >
        <ak-field label="Delimiter" margin-bottom="mb-0" required>
          <ak-input
            v-model="operation.configuration.delimiter"
            placeholder="Enter Delimiter"
            required
            maxlength="1"
          />
        </ak-field>
      </ak-pack-item>
      <!-- reference type configurable -->
      <ak-pack-item
        v-if="fileType && fileType.configurables.referenceType"
        class="one-half mb-small"
      >
        <ak-field label="Reference type" margin-bottom="mb-0" required>
          <ak-select
            v-model="referenceType"
            :options="referenceTypes"
            track-by="value"
            label="label"
            placeholder="Select Reference Type"
          />
        </ak-field>
      </ak-pack-item>
    </ak-pack>
    <ak-pack>
      <!-- root path configurable -->
      <ak-pack-item
        v-if="fileType && fileType.configurables.rootPath"
        :grow="true"
      >
        <ak-field label="Root path">
          <ak-input
            v-model="operation.configuration.rootPath"
            placeholder="Enter root path (or leave blank)"
            maxlength="50"
          />
        </ak-field>
      </ak-pack-item>
    </ak-pack>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import fileTypes from '../../constants/fileTypes'

export default defineComponent({
  name: 'AkIntegrationSFTPFileType',
  props: {
    service: {
      required: true,
      type: Object,
    },
  },
  emits: ['onUpdatedFileType', 'onUpdatedReferenceType'],
  setup(props, { emit }) {
    /**
     * Operation configuration
     * @type {RefTypes.ComputedRef<*>}
     */
    const operation = props.service.getOperation()

    /**
     * File type
     * @type {WritableComputedRef<T>}
     */
    const fileType = computed({
      get: () =>
        fileTypes.find(
          (selector) => selector.value === operation.configuration.fileType,
        ),
      set: (selected) => {
        if (!selected) return
        operation.configuration.fileType = selected.value
        emit('onUpdatedFileType')
      },
    })

    /**
     * Reference types for CSV column mapping
     * @type {[{label: string, value: string},{label: string, value: string}]}
     */
    const referenceTypes = [
      {
        label: 'Specify column header',
        value: 'header',
      },
      {
        label: 'Specify column index',
        value: 'column',
      },
    ]

    /**
     * Reference type
     * @type {WritableComputedRef<T>}
     */
    const referenceType = computed({
      get: () =>
        referenceTypes.find(
          (selector) =>
            selector.value === operation.configuration.referenceType,
        ),
      set: (selected) => {
        if (!selected) return
        operation.configuration.referenceType = selected.value
        emit('onUpdatedReferenceType')
      },
    })

    return {
      operation,
      fileTypes,
      fileType,
      referenceTypes,
      referenceType,
    }
  },
})
</script>
